import { Fragment } from 'react';

import MeetTeamEntryLargeGrid from './MeetTeamEntryLargeGrid';
import MeetTeamEntrySmallGrid from './MeetTeamEntrySmallGrid';

const MeetTeamEntryGrid = ({ gridData, isLoading, onAddEntryClicked, onEdit, onDeleteTeamEntryClicked, onView }) => {
  return (
    <Fragment>
      <MeetTeamEntryLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onAddEntryClicked={onAddEntryClicked}
        onEdit={onEdit}
        onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
        onView={onView}
      />
      <MeetTeamEntrySmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onAddEntryClicked={onAddEntryClicked}
        onEdit={onEdit}
        onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
        onView={onView}
      />
    </Fragment>
  )
};

export default MeetTeamEntryGrid;